// Module
var code = "<template>\n  <div slot=\"data\" class=\"inline-entity__form\">\n    <div class=\"inline-entity__header\">${header | t}</div>\n    <slot></slot>\n  </div>\n</template>\n";
// Exports
export default code;